//@flow
import React from 'react';
import './style.scss';
import { HTMLView } from 'components/atoms/htmlView';

type Props = {
  short_content: string,
  long_content: string,
  onClick: () => void,
  renderOverlayButton: boolean,
};

const OurDifferencePageContent = (props: Props) => {
  const { short_content, long_content, onClick, renderOverlayButton } = props;

  return (
    <div className="our-difference-page-content-body">
      <div className="short-content">
        <HTMLView
          tagName={'div'}
          html={short_content}
          className={'our-difference-description'}
        />
        {renderOverlayButton && !long_content && (
          <a onClick={onClick}>READ MORE</a>
        )}
      </div>
      <div className="long-content">
        <HTMLView
          tagName={'p'}
          html={long_content}
          className={'our-difference-description'}
        />
        {renderOverlayButton && long_content && (
          <a onClick={onClick}>READ MORE</a>
        )}
      </div>
    </div>
  );
};
export default OurDifferencePageContent;
